import { Flow } from 'signup-constants/Flow';
import { getRouteParams } from './getRouteParams';
export const getFlowKey = () => {
  const flowKey = getRouteParams().flowKey;

  if (flowKey === Flow.AcademyEmbedded) {
    return Flow.Academy;
  }

  return flowKey;
};